import { onDocumentReady, setHeaderMenuStyle } from '@theme/utilities';

const TABLET_QUERY = '(min-width: 750px) and (max-width: 1099px)';
const ADAPTER_ATTRIBUTE = 'data-atelea-header-menu-adapter';

/**
 * @param {HTMLElement} headerComponent
 * @returns {void}
 */
function mountHeaderMenuAdapter(headerComponent) {
  if (headerComponent.getAttribute(ADAPTER_ATTRIBUTE) === 'true') return;

  headerComponent.setAttribute(ADAPTER_ATTRIBUTE, 'true');
  const tabletQuery = window.matchMedia(TABLET_QUERY);

  const syncMenuStyle = () => {
    if (tabletQuery.matches) {
      headerComponent.dataset.menuStyle = 'drawer';
      return;
    }

    setHeaderMenuStyle();
  };

  const menuStyleObserver = new MutationObserver(() => {
    if (tabletQuery.matches && headerComponent.dataset.menuStyle !== 'drawer') {
      headerComponent.dataset.menuStyle = 'drawer';
    }
  });

  menuStyleObserver.observe(headerComponent, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });
  tabletQuery.addEventListener('change', syncMenuStyle);
  syncMenuStyle();
}

/**
 * @param {Document | Element} root
 * @returns {void}
 */
function start(root = document) {
  const headerComponent =
    root instanceof Element && root.matches('#header-component')
      ? root
      : root.querySelector('#header-component');

  if (headerComponent instanceof HTMLElement) {
    mountHeaderMenuAdapter(headerComponent);
  }
}

onDocumentReady(() => start());

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) start(event.target);
});
